import {useState} from 'react'
import { FiAlertCircle, FiSend } from 'react-icons/fi'
import PopUp from './PopUp'

const SendAlerts = () => {
  const [text, setText] = useState("")
  const [popUpActive, setPopUpActive] = useState(false)
  const [status, setStatus] = useState('')

  const confirmAlert = () => {
    if (!text.trim()) {
      setStatus('Write a message before sending.');
      return;
    }
    setPopUpActive(true)
  }

  const sendAlert = async () => {
    try {
      const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/launchAlert', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ alertMessage: text })
      });
      if (!res.ok) throw new Error('Failed to send alert');
      setText('')
      setStatus('Alert sent successfully.')
    } catch (err) {
      console.error('Error sending alert:', err);
      setStatus('The alert could not be sent. Please try again.')
    }
  };

  return(
    <div className="alert-admin-layout">
      <section className="dash-card form-card alert-form-card">
        <div className="dash-card-heading">
          <div><span className="dash-card-label">Broadcast message</span><h2>Send a resident alert</h2></div>
          <FiSend />
        </div>
        <p className="form-help">Approved residents who opted in will receive this message by email or text.</p>
        <label className="message-field" htmlFor="alert-message">
          <span>Message <small>{text.length} / 256</small></span>
          <textarea id="alert-message" maxLength={256} value={text} onChange={(event) => setText(event.target.value)} placeholder="Write a clear, concise community update…" />
        </label>
        <div className="alert-note"><FiAlertCircle /><span>Review names, dates, and times carefully before sending. Alerts are delivered immediately.</span></div>
        <div className="form-actions">
          <button className="primary-button" onClick={confirmAlert}><FiSend /> Review and send</button>
          {status && <span className="save-status" role="status">{status}</span>}
        </div>
      </section>
      {popUpActive && <PopUp setPopUpActive={setPopUpActive} message="Send this alert to all opted-in residents?" action={sendAlert} type="confirm" />}
    </div>
  )
}

export default SendAlerts
